import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import {api} from "./../../services/ResourceService";
import Box from '@mui/material/Box';
import { Hidden } from '@mui/material'


export default function SessionCallback(){
	const [searchParams, setSearchParams] = useSearchParams();

	const status = searchParams.get("status");
	React.useEffect(()=>{
		(async()=>{
			if(status=="cancel") api.handleError(new Error("Transaction has been canceled"))
			else{
				await api.post(`/products/transactions`, {sessionId: searchParams.get("session")}).catch(err=>null);
			}
		})();
	},[]);

	return (
		<>
		 {
			status === "success" ? 
			<Box sx={{display: "flex", flexDirection: "column", alignItems: "center"}}>
			  <img src="/flying-books.png" alt="success payment" style={{maxWidth: "100%"}}/>
			  <h2 className={"Product-info-subtitle"}>Thank you !</h2>

			 <Hidden smUp>
			 	<p style={{color: "#000"}} className="Product-info-description">Your BookNFT will be signed <br/> and delivered to your wallet.</p>
			 </Hidden>
			 <Hidden smDown>
			 	<p style={{color: "#000"}}  className="Product-info-description">Your BookNFT will be signed and delivered to your wallet.</p>
			 </Hidden>
			</Box>: 
			<></>
		 }
		</>
	)
}